import StepIndicator from "../Components/StepIndicator";
import AppHeader from "../Components/AppHeader";
import { useLoginResult } from "../State/LoginResultContext";

export default function Unauthorized() {
  
  const { loginResults } = useLoginResult();

   return (
      <div className="min-h-full flex-col">
        <AppHeader className="sm:hidden" isSuperUser={loginResults?.isSuperUser} loginResults={loginResults}/>
  
        <div className="flex flex-1 flex-col items-center px-6 py-2 sm:py-10">
          <div className="flex flex-col items-center">
            <img
              src="logo192.png"
              alt="Seymour Logo"
              className="mx-auto h-11 sm:h-20 w-auto rounded-full hidden sm:block"
            />
          </div>
  
          <div className="sm:grid sm:grid-cols-12 gap-8 w-full sm:max-w-7xl mt-6 sm:mt-10">
            <div className="col-span-3"></div>
            {/* Main column */}
            <div className="flex-1 flex flex-col items-center sm:col-span-6">
           
                  <h2 className="text-center text-lg font-extrabold text-white">
                    Unauthorized
                  </h2>
                  <p className="mt-6 sm:mt-8 text-center text-white atkinson-font w-full">
                    You do not have enough permission to perform this action.
                  
                  </p>

            </div>
  
    
          </div>
        </div>
      </div>
    );
}
